/* Model */
class I18NLocaleModel extends App.Models.BaseModel {
    modelUrl = 'I18NLocale';
}

App.Models.I18NLocale = I18NLocaleModel;

/* Collection */
class I18NLocaleCollection extends App.Collections.BaseCollection {
    url = 'I18NLocale';
    model = App.Models.I18NLocale;
}

App.Collections.I18NLocales = I18NLocaleCollection;

/* Router */
class I18NLocaleRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'I18NLocale';
        const model = App.Models.I18NLocale;
        const collectionClass = App.Collections.I18NLocales;

        super(entityName, model, collectionClass);
    }
}

App.Routers.I18NLocale = I18NLocaleRouter;
